import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { t } from 'ttag';

import FilterIcon from '@svg/ic_filter.svg';
import { Item } from '@ui/LinkFilter';
import { useInfinityScroll } from '@hook/useInfinityScroll';
import { setProductReferrerPathnameToStorage, useIsClient } from '@utils/common';
import { Button } from '@ui/Button';
import Grid from '@components/Grid';
import { SortSelect } from '@components/SortSelect';
import { FeedAside } from '@components/FeedAside';
import { ActiveFilters } from '@components/ActiveFilters';
import { ProductCard, Product } from '@components/ProductCard';
import { ProductsFeedSleketon } from '@components/ProductsFeedSleketon';
import NoProductsPlaceholder from '@components/NoProductsPlaceholder';
import { PopularCatalogsRelinking } from '@components/profile/PopularCatalogsRelinking';

import s from './ProfileProductsFeed.sss';

interface City {
  id: number,
  name: string,
}

interface Props {
  products: Product[],
  hasNextPage: boolean,
  total: number,
  catalogs: Item[]
  sizeCatalogSlug?: string | null,
  relinkingCatalogs: (Item & { slug: string })[]
  city?: City | null
  onLoadMore(): void,
}

// const
const scrollRangeToFetchMore = 1900;

export const ProfileProductsFeed: React.FC<Props> = ({
  products,
  hasNextPage,
  total,
  catalogs,
  sizeCatalogSlug,
  relinkingCatalogs,
  city,
  onLoadMore,
}) => {
  const location = useLocation();
  const isClient = useIsClient();
  const ref = useInfinityScroll(onLoadMore, scrollRangeToFetchMore);
  const [isFiltersOpened, setIsFiltersOpened] = useState(false);

  return (
    <>
      <div
        ref={ref}
        className={s.root}
      >
        <FeedAside
          placement="shop"
          total={total}
          isMobile={isFiltersOpened}
          onClose={() => setIsFiltersOpened(false)}
          catalogs={catalogs}
          isSizeFilterEnable={true}
          isBrandFilterEnable={true}
          isColorFilterEnable={true}
          isPriceFilterEnable={true}
          isConditionFilterEnable={true}
          sizeCatalogSlug={sizeCatalogSlug}
        />
        <main className={s.main}>
          <div className={s.controls}>
            {isClient && (
            <SortSelect className={s.sort} />
            )}

            <Button
              className={s.filtersButton}
              theme="secondary"
              onClick={() => setIsFiltersOpened(true)}
            >
              <FilterIcon className={s.filtersIcon} />
              {t`Фільтри`}
            </Button>
          </div>
          <div className={s.activeFilters}>
            <ActiveFilters sizeCatalogSlug={sizeCatalogSlug} />
          </div>

          {!products.length ? (
            <NoProductsPlaceholder
              className={s.notFound}
              withImage={false}
              title={t`Схоже нічого не знайдено`}
              subTitle={t`Спробуйте уточнити або змінити запит`}
            />
          ) : (
            <Grid
              container={true}
              spacing={10}
            >
              {products.map((product) => (
                <Grid
                  key={product.id}
                  desktop={3}
                  tablet={4}
                  def={6}
                >
                  <ProductCard
                    {...product}
                    onProductClick={() => {
                      setProductReferrerPathnameToStorage({
                        productId: product.id,
                        pathname: location.pathname,
                      });
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )}

          {hasNextPage && (
          <ProductsFeedSleketon count={4} />
          )}
        </main>
      </div>
      <PopularCatalogsRelinking
        className={s.relinking}
        links={relinkingCatalogs}
        city={city}
      />
    </>
  );
};
